/**
 * Env wrapper for MutationObserver
 * https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver
 * @module
 */

exports.create = function(callback) {
  return new MutationObserver(callback);
};

/**
 * Configures an instance of MutationObserver to observe the
 * specified target with the specified config.
 * @param {MutationObserver} observerInstance
 * @param {Node} target
 * @param {Object} config
 */
exports.observe = function(observerInstance:MutationObserver, target:Node, config:any) {
  observerInstance.observe(target, config);
};

if (__EXPERIMENTAL_SHADOW_DOM__) {
  // TODO move this observer to @optimizely/shadow-dom-utils
  var observeShadowMutation = require('ally.js').observe.shadowMutations;
  exports.ShadowDomMutationObserver = function (callback) {
      this.observe = function (context, config) {
        var instance = observeShadowMutation({
          context,
          callback,
          config,
        });
        this.disconnect = instance.disengage;
      };
  };
}
